import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import FastDebtConsolidationWrapper from "@components/layouts/fastDebtConsolidationWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import colors from "@styles/variables/fastdebtconsolidationVariables.module.scss";

export default function FastDebtConsolidationHome(): ReactElement {
    return (
        <FastDebtConsolidationWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={colors.mainColor} />
            </div>
            <FormSection iconsFillColor={colors.mainColor} />
        </FastDebtConsolidationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
